import {
	BOOKING_LIST_DATA,
	BOOKING_LIST_FAILED,
	BOOKING_LIST_LOADING,
	BOOKING_FILTER_DATA_VALUES,
	BOOKING_FILTER_DATA_LOADING,
	BOOKING_FILTER_DATA_FAILED,
	GET_BOOKING_DETAIL_DATA_LOADING,
	GET_BOOKING_DETAIL_DATA_SUCCESS,
	GET_BOOKING_DETAIL_DATA_FAILED,
	CONTAINERS_LIST_LOADING,
	CONTAINERS_LIST_DATA,
	CONTAINERS_LIST_FAILED,
	BOOKING_DOCUMENT_LOADING,
	BOOKING_DOCUMENT_DATA,
	BOOKING_DOCUMENT_FAILED
} from './actionTypes';

// Get All Bookings
export const getAllBookingData = data => {
	return {
		type: BOOKING_LIST_DATA,
		payload: data
	};
};

export const getAllBookingDataLoading = filterData => {
	return {
		type: BOOKING_LIST_LOADING,
		payload: filterData
	};
};

export const getAllBookingDataError = message => {
	return {
		type: BOOKING_LIST_FAILED,
		payload: message
	};
};

// Get Booking Detail
export const getBookingDetailDataLoading = bookingId => {
	return {
		type: GET_BOOKING_DETAIL_DATA_LOADING,
		payload: bookingId
	};
};

export const getBookingDetailDataSuccess = data => {
	return {
		type: GET_BOOKING_DETAIL_DATA_SUCCESS,
		payload: data
	};
};

export const getBookingDetailDataError = message => {
	return {
		type: GET_BOOKING_DETAIL_DATA_FAILED,
		payload: message
	};
};

// Get Booking Filter Data
export const getBookingFilterData = data => {
	return {
		type: BOOKING_FILTER_DATA_VALUES,
		payload: data
	};
};

export const getBookingFilterDataLoading = data => {
	return {
		type: BOOKING_FILTER_DATA_LOADING,
		payload: data
	};
};

export const getBookingFilterDataError = message => {
	return {
		type: BOOKING_FILTER_DATA_FAILED,
		payload: message
	};
};

//Get Booking Containers
export const getBookingContainersSuccess = data => {
	return {
		type: CONTAINERS_LIST_DATA,
		payload: data
	};
};

export const getBookingContainersLoading = bookingId => {
	return {
		type: CONTAINERS_LIST_LOADING,
		payload: bookingId
	};
};

export const getBookingContainersError = message => {
	return {
		type: CONTAINERS_LIST_FAILED,
		payload: message
	};
};

// Get Booking Document
export const getBookingDocumentSuccess = data => {
	return {
		type: BOOKING_DOCUMENT_DATA,
		payload: data
	};
};

export const getBookingDocumentError = message => {
	return {
		type: BOOKING_DOCUMENT_FAILED,
		payload: message
	};
};

export const getBookingDocumentLoading = bookingId => {
	return {
		type: BOOKING_DOCUMENT_LOADING,
		payload: bookingId
	};
};
